import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="w-full border-t border-ink/10 bg-paper-deep px-8 py-24 sm:px-14 sm:py-32" data-id="element-74" data-mp="1lc231ky1rhuv">
      <div className="mx-auto grid max-w-6xl gap-12 lg:grid-cols-12" data-id="element-75" data-mp="1gal3bsrau1fv">
        <h2 className="self-start font-display text-[2.6rem] leading-[1.02] tracking-tight text-ink sm:text-6xl lg:sticky lg:top-24 lg:col-span-4" data-id="element-76" data-mp="2dzxt46t42bio">
          Questions <em className="text-pen" data-id="element-77" data-mp="241qqyu3hdy0q">fréquentes</em>
        </h2>

        <div className="border-t border-ink/15 lg:col-span-8" data-id="element-78" data-mp="244cw6n2wg1fs">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          const panelId = `faq-panel-${index}`;
          return <div key={faq.q} className="border-b border-ink/15" data-id="element-79" data-mp="no0cquindtdd" data-mpi={index}>
                <h3 data-id="element-80" data-mp="nmp8yup7clm9">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={panelId} className="group flex w-full items-center justify-between gap-6 py-6 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-pen/40" data-id="element-81" data-mp="phy2hnces7vh">
                    <span className="font-display text-xl leading-snug text-ink sm:text-2xl" data-id="element-82" data-mp="6rg8zgjr5892">{faq.q}</span>
                    <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full border transition-colors duration-150 ease-out ${isOpen ? 'border-ink bg-ink text-paper' : 'border-ink/20 text-ink group-hover:border-ink/50'}`} data-id="element-83" data-mp="bhwrhf2fjk2a">
                      <PlusIcon className={`h-4 w-4 transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-84" data-mp="3nzk19h4mmx9h" />
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-85" data-mp="1pobc7892bwpz">
                  {isOpen && <motion.div id={panelId} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-86" data-mp="1koynsj2jmhla">
                      <p className="max-w-2xl pb-7 pr-14 leading-relaxed text-ink/75" data-id="element-87" data-mp="23jm1850mlnmf">{faq.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}